import { Divider } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import DriveDateIcon from 'components/icons/DriveDateIcon'
import DriveDetailsIcon from 'components/icons/DriveDetailsIcon'
import StatusIcon from 'components/icons/StatusIcon'
import DriveStatus from 'modules/Roles/ViewRole/CollegesTable/AddRoleToExistingDriveDrawer/DriveStatus'
import React, { useEffect, useState } from 'react'

import {
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
  DreiveDetailFlex,
  DriveDetailsHead,
  DriveDetailsViewDiv,
  DriveInfoFlex,
  DriveNameDiv,
  DriveStatusFlex,
  DriveTypeDiv,
  DriveTypeFlex,
  IconSpan,
  RoleCand,
  RoleNameDiv,
  RolesDiv,
  RolesFlex,
  RolesInfoDiv,
} from 'modules/Roles/ViewRole/CollegesTable/AddRoleToExistingDriveDrawer/style.js'
import ApplyFilter from 'modules/Roles/ViewRole/DriveDrawers/DrivesUiComponents/FilterPart'
import { useParams } from 'react-router-dom'
import { getDay } from 'utils/getDay'
import { getIdFormate } from 'utils/getZeroBeforeInt'
import { roleBasedDegreeListConvertion } from 'utils/roleBasedDegreeListConvertion'

const AddRoleToExistingDriveDrawer = ({
  existingDrivePreview,
  setExistingDrivePreview,
  degreeListData,
  degreeSearch,
  setDegreeSearch,

  driveData,
  driveRolesMetrics,
  singleRoleData,
  getAppliedCandidateList,
  addRoleToExistingDrive,
  reloadPage,

  getDegreesBasedOnRoles,
  roleBasedDegreeList,
}) => {
  const params = useParams()
  const [loading, setLoading] = useState(false)

  const [applyFilter, setApplyFilter] = useState(false)
  const [previewConfirm, setPreviewConfirm] = useState(false)
  const [studentRating, setStudentRating] = useState('')
  const [minScore, setMinScore] = useState('')
  const [degreeDepartment, setDegreeDepartment] = useState('')
  const [selectedInstitute, setSelectedInstitute] = useState({})
  const [errors, setErrors] = useState({
    filterError: '',
  })
  const [shortlistedCandidates, setShortlistedCandidates] = useState({})
  const [rolesDegreeList, setRolesDegreeList] = useState([])

  const shortlisted = async () => {
    let { data, status } = await getAppliedCandidateList({
      roleId: params?.jobId,
      setLoading: setLoading,
      searchByRating: studentRating,
      searchByPercentage: minScore,
      searchByDegree: degreeDepartment,
      filterData: {
        collegeName:
          driveData?.hostCollegeId &&
          driveData?.poolDriveInstituteCampusMap?.length
            ? `${
                driveData?.hostCollegeId
              },${driveData?.poolDriveInstituteCampusMap
                ?.map(item => item?.instituteCampusId)
                ?.toString()}`
            : driveData?.hostCollegeId
            ? driveData?.hostCollegeId
            : '',
      },
    })
    if (status >= 200 && status < 300) {
      setShortlistedCandidates(data?.data)
    }
    if (status >= 400) {
      setShortlistedCandidates({})
    }
  }

  useEffect(() => {
    if (existingDrivePreview) {
      shortlisted()
    }
  }, [studentRating, minScore, degreeDepartment, existingDrivePreview])

  useEffect(() => {
    setSelectedInstitute({ id: driveData?.hostCollegeId })
  }, [])

  useEffect(() => {
    getDegreesBasedOnRoles({ jobId: params?.jobId })
  }, [params?.jobId])

  useEffect(() => {
    const updatedData = roleBasedDegreeListConvertion({
      listOfDegree: roleBasedDegreeList,
      parentNameParam: 'degree',
      parentValueParam: 'degreeId',
      pathName: 'streams',
      childrenValueParam: 'degreeStreamMapId',
    })
    setRolesDegreeList(updatedData)
  }, [roleBasedDegreeList])

  const handleConfirm = action => {
    if (action == 'preview') {
      if (
        applyFilter &&
        !studentRating &&
        !minScore &&
        degreeDepartment == ''
      ) {
        setErrors({ filterError: 'Minimum one filter required.' })
      } else {
        setPreviewConfirm(true)
      }
    }
    if (action == 'confirm') {
      let payload = {}

      if (studentRating) {
        payload = { ...payload, studentMinRating: studentRating }
      }
      if (minScore) {
        payload = { ...payload, minScore: minScore }
      }
      if (degreeDepartment) {
        payload = { ...payload, degreeStreamMapId: degreeDepartment }
      }
      handleAddRole(payload)
    }
  }

  const handleAddRole = async payload => {
    const response = await addRoleToExistingDrive({
      setLoading: setLoading,
      roleId: params?.jobId,
      driveId: driveData?.id,
      payload: payload,
    })

    if (response?.status >= 200 && response?.status <= 300) {
      handleOnClose()
      reloadPage()
    }
  }

  const handleOnClose = () => {
    setExistingDrivePreview(false)
    setApplyFilter(false)
    setStudentRating('')
    setMinScore('')
    setDegreeDepartment('')
    setErrors({ filterError: '' })
    setPreviewConfirm(false)
  }

  const content = () => {
    return (
      <>
        <DriveDetailsHead>
          Drive ID - {getIdFormate(driveData?.serialNo)}
        </DriveDetailsHead>
        <DriveDetailsViewDiv>
          <DreiveDetailFlex>
            <AntdAvatar
              size={36}
              IconName={driveData?.hostCollegeName?.charAt(0)?.toUpperCase()}
            />
            <CollageNameFlex>
              <CollegeNameDiv>{driveData?.hostCollegeName}</CollegeNameDiv>
              <CollegeCity>{driveData?.city}</CollegeCity>
            </CollageNameFlex>
          </DreiveDetailFlex>
          <DriveInfoFlex spaceBetween>
            <DriveTypeFlex column center>
              <IconSpan>
                <DriveDetailsIcon />
              </IconSpan>

              <DriveTypeDiv>Drive Type</DriveTypeDiv>
              <DriveNameDiv>
                {driveData?.driveMode?.split('_')?.join(' ')}
              </DriveNameDiv>
            </DriveTypeFlex>
            <DriveTypeFlex column center>
              <IconSpan>
                <DriveDateIcon />
              </IconSpan>
              <DriveTypeDiv>Drive Date</DriveTypeDiv>
              <DriveNameDiv>
                {driveData?.startDate
                  ? getDay(driveData?.startDate, true)
                  : '-'}
              </DriveNameDiv>
            </DriveTypeFlex>

            <DriveStatusFlex column center>
              <IconSpan>
                <StatusIcon />
              </IconSpan>
              <DriveTypeDiv>Status</DriveTypeDiv>
              <DriveStatus status={driveData?.corporateStatus} />
            </DriveStatusFlex>
          </DriveInfoFlex>
          {!previewConfirm && (
            <>
              <RolesDiv>Roles</RolesDiv>
              {driveRolesMetrics?.map((item, index) => (
                <RolesFlex
                  key={index + item?.roleName}
                  spaceBetween
                  padding={'8px 0'}
                >
                  <RoleNameDiv>{item?.roleName}</RoleNameDiv>
                  <RoleCand>
                    {item?.candidateCount}{' '}
                    {item?.candidateCount == '1' ? 'Candidate' : 'Candidates'}
                  </RoleCand>
                </RolesFlex>
              ))}
            </>
          )}
        </DriveDetailsViewDiv>

        {!previewConfirm && (
          <>
            <RolesDiv>Role</RolesDiv>
            <RolesFlex spaceBetween borderBottom={'0'} padding={'5px 0'}>
              <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
            </RolesFlex>
            <Divider />

            <ApplyFilter
              applyFilter={applyFilter}
              setApplyFilter={setApplyFilter}
              studentRating={studentRating}
              setStudentRating={setStudentRating}
              minScore={minScore}
              setMinScore={setMinScore}
              degreeDepartment={degreeDepartment}
              setDegreeDepartment={setDegreeDepartment}
              degreeListData={degreeListData}
              setDegreeSearch={setDegreeSearch}
              selectedInstitute={selectedInstitute}
              count={shortlistedCandidates?.count}
              errors={errors}
              setErrors={setErrors}
              rolesDegreeList={rolesDegreeList}
            />
          </>
        )}

        {!!previewConfirm && (
          <>
            <RolesDiv>Roles</RolesDiv>
            <RolesInfoDiv margin={'10px 0 30px 0'}>
              {driveRolesMetrics?.map((item, index) => (
                <RolesFlex key={index + item?.roleName} spaceBetween>
                  <RoleNameDiv>{item?.roleName}</RoleNameDiv>
                  <RoleCand>
                    {item?.candidateCount}{' '}
                    {item?.candidateCount == '1' ? 'Candidate' : 'Candidates'}
                  </RoleCand>
                </RolesFlex>
              ))}
              <RolesFlex spaceBetween>
                <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
                <RoleCand>
                  {shortlistedCandidates?.count}{' '}
                  {shortlistedCandidates?.count == '1'
                    ? 'Candidate'
                    : 'Candidates'}
                </RoleCand>
              </RolesFlex>
            </RolesInfoDiv>
          </>
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <DriveStatusFlex flexEnd>
        <Button.Secondary
          onClick={() =>
            previewConfirm ? setPreviewConfirm(false) : handleOnClose()
          }
          text={previewConfirm ? 'Back to edit' : 'Cancel'}
        />
        <Button.Primary
          loading={loading}
          disabled={!shortlistedCandidates?.count}
          onClick={() => handleConfirm(previewConfirm ? 'confirm' : 'preview')}
          text={previewConfirm ? 'Confirm' : 'Preview & Confirm'}
        />
      </DriveStatusFlex>
    )
  }
  return (
    <Drawer
      width="42%"
      title={'Add role to existing drive'}
      placement="right"
      visible={existingDrivePreview}
      content={content()}
      footer={footer()}
      closable={true}
      onClose={() => handleOnClose()}
    />
  )
}

export default AddRoleToExistingDriveDrawer
